import React from "react";
import ContentWrapper from "../components/layout/ContentWrapper";
import { useCustomTranslation } from "../helpers/translateHelpers";

const NotFoundPage: React.FC = (): React.ReactElement => {
  const { t } = useCustomTranslation();

  return (
    <ContentWrapper largePadding htmlTitle={t("not_found_text")}>
      <h2>{t("not_found_text")}</h2>
    </ContentWrapper>
  );
};

export default NotFoundPage;
